/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable max-len */
import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import AttendAllowanceIndexLayoutPage from 'components/organismos/AttendAllowance/AttendAllowanceIndexPage/AttendAllowanceIndexLayoutPage';

const AttendAllowanceIndexPage: React.FC = () => (
  <SidebarTemplate
    pageTitle="手当マスタ"
  >
    <AttendAllowanceIndexLayoutPage />
  </SidebarTemplate>
);

export default AttendAllowanceIndexPage;
